export enum WrappingSwimLaneOverflow {
  Off = 'Off',
  TwoLanes = 'TwoLanes',
  ThreeLanes = 'ThreeLanes',
  FourLanes = 'FourLanes'
}
